<template>
	<slot />
</template>

<style lang="scss">
.columns-container {
	display: flex;
	flex-direction: column;
	gap: 0 48px;

	@include media('<tablet') {
		padding-left: 16px;
		padding-right: 16px;
	}

	@include media('>=tablet') {
		flex-direction: row;
	}
}

.columns-reverse {
	@include media('<tablet') {
		flex-direction: column-reverse;
	}
}

.column-content {
	@include media('>=tablet') {
		flex: 1;
	}
}

.column--two-third {
	@include media('>=tablet') {
		flex: 2;
	}
}
</style>
